import { Icon } from '@shared/ui/components/Icon';
import { PaginationItemProps } from '@shared/ui/components/Pagination/Pagination.types';

export function createItems(page: number, pages: number) {
  if (!page || !pages || page > pages) {
    return [];
  }

  // Start with the current page
  let items: PaginationItemProps[] = [{ page, isCurrent: true }];

  // Pad left and right with additional page numbers
  for (let i = 0; i < 4; i++) {
    const firstVisiblePage = items[0].page;
    const lastVisiblePage = items[items.length - 1].page;

    if (i % 2 === 0 && firstVisiblePage > 1) {
      items = [{ page: firstVisiblePage - 1 }].concat(items);
    } else if (i % 2 === 0 && lastVisiblePage < pages) {
      items = items.concat([{ page: lastVisiblePage + 1 }]);
    } else if (i % 2 === 1 && lastVisiblePage < pages) {
      items = items.concat([{ page: lastVisiblePage + 1 }]);
    } else if (i % 2 === 1 && firstVisiblePage > 1) {
      items = [{ page: firstVisiblePage - 1 }].concat(items);
    }
  }

  // Add ellipses left if there are more pages
  if (items[0].page > 3) {
    items = ([{ page: 1 }, { label: '…' }] as PaginationItemProps[]).concat(items);
  } else if (items[0].page > 2) {
    items = ([{ page: 1 }, { page: 2 }] as PaginationItemProps[]).concat(items);
  } else if (items[0].page > 1) {
    items = ([{ page: 1 }] as PaginationItemProps[]).concat(items);
  }

  // Add previous left if there is a previous page
  if (page > 1) {
    items = ([{ page: page - 1, label: <Icon icon="angle-left" /> }] as PaginationItemProps[]).concat(items);
  } else {
    items = ([{ label: <Icon icon="angle-left" /> }] as PaginationItemProps[]).concat(items);
  }

  // Add ellipses right if there are more pages
  if (items[items.length - 1].page < pages - 2) {
    items = items.concat([{ label: '…' }, { page: pages }] as PaginationItemProps[]);
  } else if (items[items.length - 1].page < pages - 1) {
    items = items.concat([{ page: pages - 1 }, { page: pages }] as PaginationItemProps[]);
  } else if (items[items.length - 1].page < pages) {
    items = items.concat([{ page: pages }] as PaginationItemProps[]);
  }

  // Add next right if there is a next page
  if (page < pages) {
    items = items.concat([{ page: page + 1, label: <Icon icon="angle-right" /> }] as PaginationItemProps[]);
  } else {
    items = items.concat([{ label: <Icon icon="angle-right" /> }] as PaginationItemProps[]);
  }

  return items;
}
